import { Serializable } from '@dynameat/models';
import i18n from '@core/plugins/i18n';
import { DEFAULT_LOCALE } from '@core/constants';

export class MenuEdition extends Serializable {
  constructor(guid = new Date().getTime().toString()) {
    super();
    this.guid = guid;
  }

  translateAttribute(attribute) {
    const localizedAttr = this[`${attribute}_${i18n.locale}`];
    if (!localizedAttr) return this[`${attribute}_${DEFAULT_LOCALE}`];
    return localizedAttr;
  }
}
